import { DeleteIcon } from "@chakra-ui/icons";
import { FC } from "react";

import { Schematisation } from "@nens/threedi/openapi-client";

import ButtonWithConfirmation from "../../components/ButtonWithConfirmation";
import { useDeleteSchematisation } from "../../queries/schematisations";

interface DeleteSchematisationButtonProps {
  schematisation: Schematisation;
}

const DeleteSchematisationButton: FC<DeleteSchematisationButtonProps> = ({ schematisation }) => {
  const deleteSchematisation = useDeleteSchematisation(schematisation.id);

  return (
    <ButtonWithConfirmation
      buttonText="Delete schematisation"
      dialogTitle="Really delete?"
      confirmationButtonText="Delete"
      confirmationButtonSafety="dangerous"
      onClick={deleteSchematisation}
      buttonIcon={<DeleteIcon boxSize={5} />}
      disableAfterClick
      timer
      w={"250px"}
      needsCreatorRole
    >
      <p>
        This deletes this schematisation, all its revisions and their Rana models. This action
        cannot be undone.
      </p>
    </ButtonWithConfirmation>
  );
};

export default DeleteSchematisationButton;
